import { createAction, props } from '@ngrx/store';
import { GroupedNotificationsResponse, NotificationsByTypeResponse } from '../models/notifications-grouped.model';

export const NotificationsDrawerActions = {
  loadNotifications: createAction('[Notifications Drawer] Load Notifications'),

  loadNotificationsSuccess: createAction(
    '[Notifications Drawer] Load Notifications Success',
    props<{ response: GroupedNotificationsResponse }>()
  ),

  loadNotificationsFailure: createAction(
    '[Notifications Drawer] Load Notifications Failure',
    props<{ error: string }>()
  ),

  loadMoreForType: createAction(
    '[Notifications Drawer] Load More For Type',
    props<{ typeCode: string; refillCount?: number }>()
  ),

  loadMoreForTypeSuccess: createAction(
    '[Notifications Drawer] Load More For Type Success',
    props<{ typeCode: string; response: NotificationsByTypeResponse; appendCount?: number }>()
  ),

  loadMoreForTypeFailure: createAction(
    '[Notifications Drawer] Load More For Type Failure',
    props<{ typeCode: string; error: string }>()
  ),

  markAsRead: createAction('[Notifications Drawer] Mark As Read', props<{ notificationId: number }>()),

  markAsReadSuccess: createAction('[Notifications Drawer] Mark As Read Success', props<{ notificationId: number }>()),

  deleteNotification: createAction(
    '[Notifications Drawer] Delete Notification',
    props<{ notificationId: number; typeCode: string }>()
  ),

  deleteNotificationSuccess: createAction(
    '[Notifications Drawer] Delete Notification Success',
    props<{ notificationId: number; typeCode: string; wasUnread: boolean }>()
  ),
  loadNotificationCount: createAction('[Notifications] Load Notification Count'),

  loadNotificationCountSuccess: createAction(
    '[Notifications] Load Notification Count Success',
    props<{ unreadCount: number }>()
  ),

  loadNotificationCountFailure: createAction(
    '[Notifications] Load Notification Count Failure',
    props<{ error: string }>()
  ),

  toggleSectionExpansion: createAction(
    '[Notifications Drawer] Toggle Section Expansion',
    props<{ typeCode: string }>()
  ),

  resetNotificationsDrawer: createAction('[Notifications Drawer] Reset')
};
